import { c as _c } from "react/compiler-runtime";
import { CreateWaveOutcomeConfigWinner, CreateWaveOutcomeConfigWinnersCreditValueType, CreateWaveOutcomeType } from "@/types/waves.types";
export default function CreateWaveOutcomesWinnersRow(t0) {
  const $ = _c(24);
  const {
    winner,
    winnersCount,
    creditValueType,
    i,
    outcomeType,
    isError,
    removeWinner,
    onWinnerValueChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CreateWaveOutcomeType.MANUAL]: "Manual",
      [CreateWaveOutcomeType.REP]: "Rep",
      [CreateWaveOutcomeType.NIC]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const OUTCOME_TYPE_LABELS = t1;
  let t2;
  if ($[1] !== i || $[2] !== onWinnerValueChange) {
    t2 = e => {
      const value = parseInt(e.target.value);
      if (!isNaN(value)) {
        onWinnerValueChange({
          value,
          index: i
        });
      } else {
        onWinnerValueChange({
          value: 0,
          index: i
        });
      }
    };
    $[1] = i;
    $[2] = onWinnerValueChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onValueChange = t2;
  const showRemove = winnersCount > 1;
  const inputEndLabel = creditValueType === CreateWaveOutcomeConfigWinnersCreditValueType.PERCENTAGE ? "%" : OUTCOME_TYPE_LABELS[outcomeType];
  const t3 = `${isError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error tw-text-error" : "tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400 tw-text-white"} tw-form-input tw-block tw-px-4 tw-pb-3 tw-pt-4 tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer
tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t4;
  if ($[4] !== onValueChange || $[5] !== t3 || $[6] !== winner.value) {
    t4 = <input type="text" value={winner.value} onChange={onValueChange} autoComplete="off" className={t3} placeholder=" " />;
    $[4] = onValueChange;
    $[5] = t3;
    $[6] = winner.value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${isError ? "peer-focus:tw-text-error tw-text-error" : "peer-focus:tw-text-primary-400 tw-text-iron-500"} tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 
              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  const t6 = i + 1;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <label className={t5}>#{t6}</label>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== inputEndLabel) {
    t8 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><span className="tw-text-iron-500 tw-text-sm tw-font-normal">{inputEndLabel}</span></div>;
    $[11] = inputEndLabel;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className="tw-relative">{t4}{t7}{t8}</div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== i || $[18] !== removeWinner || $[19] !== showRemove) {
    t10 = showRemove && <div className="tw-mt-3 tw-ml-3"><button onClick={() => removeWinner(i)} type="button" aria-label="Remove" className="tw-h-8 tw-w-8 hover:tw-bg-iron-800 tw-text-iron-300 tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 tw-rounded-full focus:tw-scale-90 tw-transform tw-transition tw-duration-300 tw-ease-out"><svg className="tw-cursor-pointer tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button></div>;
    $[17] = i;
    $[18] = removeWinner;
    $[19] = showRemove;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div><div className="tw-flex">{t9}{t10}</div></div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}